export default [
    {
    login: "davidgustys",
    id: 627037,
    node_id: "MDQ6VXNlcjYyNzAzNw==",
    avatar_url: "https://avatars.githubusercontent.com/u/627037?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/davidgustys",
    html_url: "https://github.com/davidgustys",
    followers_url: "https://api.github.com/users/davidgustys/followers",
    following_url: "https://api.github.com/users/davidgustys/following{/other_user}",
    gists_url: "https://api.github.com/users/davidgustys/gists{/gist_id}",
    starred_url: "https://api.github.com/users/davidgustys/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/davidgustys/subscriptions",
    organizations_url: "https://api.github.com/users/davidgustys/orgs",
    repos_url: "https://api.github.com/users/davidgustys/repos",
    events_url: "https://api.github.com/users/davidgustys/events{/privacy}",
    received_events_url: "https://api.github.com/users/davidgustys/received_events",
    type: "User",
    site_admin: false
    },
    {
    login: "jelsonjay",
    id: 50907905,
    node_id: "MDQ6VXNlcjUwOTA3OTA1",
    avatar_url: "https://avatars.githubusercontent.com/u/50907905?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/jelsonjay",
    html_url: "https://github.com/jelsonjay",
    followers_url: "https://api.github.com/users/jelsonjay/followers",
    following_url: "https://api.github.com/users/jelsonjay/following{/other_user}",
    gists_url: "https://api.github.com/users/jelsonjay/gists{/gist_id}",
    starred_url: "https://api.github.com/users/jelsonjay/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/jelsonjay/subscriptions",
    organizations_url: "https://api.github.com/users/jelsonjay/orgs",
    repos_url: "https://api.github.com/users/jelsonjay/repos",
    events_url: "https://api.github.com/users/jelsonjay/events{/privacy}",
    received_events_url: "https://api.github.com/users/jelsonjay/received_events",
    type: "User",
    site_admin: false
    }
    ];